export default "__VITE_ASSET__CEOcR7C0__"